/**
 * configurator API
 * configurator API documentation
 *
 * OpenAPI spec version: 0.0.1
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { FtpClient } from './ftpClient';
import { S3ClientWithName } from './s3ClientWithName';

export interface FileConnection {
    id?: string;
    name?: string;
    description?: string;
    type?: FileConnection.TypeEnum;
    partner?: string;
    s3?: S3ClientWithName;
    ftp?: FtpClient;
}
export namespace FileConnection {
    export type TypeEnum = 'S3' | 'FTP';
    export const TypeEnum = {
        S3: 'S3' as TypeEnum,
        FTP: 'FTP' as TypeEnum
    };
}
